import { useQuery } from "@tanstack/react-query";
import {
  type PendingRoleIntentsResult,
  getIdentitiesRolesIntents,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const PENDING_ROLE_INTENTS_QUERY_KEY = "PENDING_ROLE_INTENTS";

export const pendingRoleIntentsKeys = {
  all: [PENDING_ROLE_INTENTS_QUERY_KEY],
};

/**
 * Pending role invitations from affiliate deep-links — drives the dashboard
 * "Dokončit registraci jako…" banner. An intent retires once the role completes.
 */
export const useGetPendingRoleIntentsQuery = (enabled = true) =>
  useQuery<PendingRoleIntentsResult>({
    queryKey: pendingRoleIntentsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getIdentitiesRolesIntents(),
    ),
    enabled,
  });
